import { render, staticRenderFns } from "./AboutUsDialog.vue?vue&type=template&id=ad4a3866&scoped=true"
import script from "./AboutUsDialog.vue?vue&type=script&lang=js"
export * from "./AboutUsDialog.vue?vue&type=script&lang=js"
import style0 from "./AboutUsDialog.vue?vue&type=style&index=0&id=ad4a3866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4a3866",
  null
  
)

export default component.exports